import { render, staticRenderFns } from "./DirectImageUploader.vue?vue&type=template&id=0496a342&scoped=true"
import script from "./DirectImageUploader.vue?vue&type=script&lang=js"
export * from "./DirectImageUploader.vue?vue&type=script&lang=js"
import style0 from "./DirectImageUploader.vue?vue&type=style&index=0&id=0496a342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496a342",
  null
  
)

export default component.exports